import React from 'react';

export default class WebErrorBoundary extends React.Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    const source = typeof error?.stack === 'string' ? error.stack.match(/\/static\/js\/[^?\s)]+/)?.[0] : null;
    window.__SHONAN_WEB_ERRORS__?.show('WEB-RENDER-001', { source });
  }

  render() {
    if (this.state.failed) {
      return <main role="alert" style={{ padding: 32, background: '#fff', color: '#18181b' }}>
        <h1>页面暂时无法显示 / Unable to display this page</h1>
        <p>错误代码 / Error code: WEB-RENDER-001</p>
        <button type="button" onClick={() => window.location.reload()}>重新加载 / Reload</button>
      </main>;
    }
    return this.props.children;
  }
}
